import PropTypes from "prop-types";
import ProductPrice from "../../../block-elements/product-price/product-price";
import ExpandContent from "../../../block-elements/expand-content/expand-content";
import SiteConfigurationStore from "components/stores/site-configuration-store";

const ProductInfo = (props) => {
  const styles = props.styles;

  const priceBlock = SiteConfigurationStore.siteConfiguration.enableBlackWeekOffer ? (
    <p data-contentful-label-id="BW_PRODUCT_INFO_TEXT" className={styles.bwTextProductInfo}>
      {SiteConfigurationStore.getLabel("BW_PRODUCT_INFO_TEXT", "Ingår i Black week-erbjudandet!")}
    </p>
  ) : (
    <ProductPrice
      price={props.baseProduct.price}
      previousPrice={props.baseProduct.previousPrice}
      currencyDisplayName={props.currencyDisplayName}
      priceClassName="h4"
      customPriceText={props.customPriceText}
      ignoreComponentTheme={true}
    />
  );

  return (
    <div className="block--max-width-narrow">
      <div className={styles.info}>
        <h2 className={["h1", styles.productName].join(" ")}>{props.productName}</h2>
        {priceBlock}
        <div dangerouslySetInnerHTML={{ __html: props.description }}></div>
        {props.readMoreBody && (
          <div className={styles.readMoreWrapper}>
            <ExpandContent expandLabel={props.readMoreLabel ? props.readMoreLabel : undefined}>
              <div dangerouslySetInnerHTML={{ __html: props.readMoreBody }} className={styles.readMoreWrapper}></div>
            </ExpandContent>
          </div>
        )}
        {!props.hasJetshop && props.customCtaText && <h5>{props.customCtaText}</h5>}
      </div>
    </div>
  );
};

ProductInfo.propTypes = {
  styles: PropTypes.object,
  productName: PropTypes.string,
  baseProduct: PropTypes.object,
  currencyDisplayName: PropTypes.string,
  customPriceText: PropTypes.string,
  description: PropTypes.string,
  readMoreLabel: PropTypes.string,
  readMoreBody: PropTypes.string,
  customCtaText: PropTypes.string,
  hasJetshop: PropTypes.bool,
};

export default ProductInfo;
